// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Tx9h","badges":"styles_badges__28Zr_"};